import React, { useState, useEffect } from "react";
import { StyledDialog, StyledButton, StyledBox, StyledTypo, StyledPaper } from "../StyledMui";
import { Popper, InputAdornment, TextField, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Paper, Typography, Select, MenuItem, Button, IconButton, DialogTitle, DialogContent, DialogActions, DialogContentText } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useStore from "../Store";

function Mapper(props) {
  const [selectedField, setSelectedField] = useState("");
  const [mappedField, setMappedField] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = React.useState("");
  const { defields, datas, setDatas, setMapping, initData, isInit, toggleIsInit, contacts, getContacts, sendTarget, setSendTarget } = useStore((state) => state.mapper);
  const [labels, setLabels] = useState([]);
  const [isCustomInput, setIsCustomInput] = useState(null); // 각 Select에 대한 상태를 저장하는 배열로 변경

  const { selectedTemplate } = useStore((state) => state.header);

  useEffect(() => {
    console.log("datas : ", datas);
  }, [datas]);

  useEffect(() => {
    console.log("selectedTemplate : ", selectedTemplate, isInit);
    if (selectedTemplate && isInit === true && initData && Object.keys(initData).length > 0) {
      toggleIsInit();
      //console.log('init mapping : ',initData, JSON.parse(initData.mapping))
      if (initData.mapping && Object.keys(JSON.parse(initData.mapping)).length > 0) {
        let init_datas = JSON.parse(initData.mapping),
          parsedLabels = init_datas.map((el) => ({ value: el.name, context: el.context }));
        if (initData.recipientMapping) setSendTarget(JSON.parse(initData.recipientMapping) || sendTarget);
        setLabels(parsedLabels);
        setDatas(init_datas);
      }
    } else if (selectedTemplate) {
      let targetTexts =
          selectedTemplate.templateMessageType === "FC"
            ? [1, 2, 3, 4, 5, 6].reduce((a, c) => {
                a += selectedTemplate[`carouselHeader${c}`] || "";
                a += selectedTemplate[`carouselMessage${c}`] || "";
                return a;
              }, "")
            : selectedTemplate.templateMessageType === "FL"
            ? [1, 2, 3, 4].reduce((a, c) => {
                a += selectedTemplate[`itemListTitle${c}`] || "";
                return a;
              }, selectedTemplate.itemListHeader || "")
            : /**/ selectedTemplate.templateContent,
        labelMatches = targetTexts?.match(/#\{[^}]+\}/g)?.map((label) => ({ value: label, context: "template" })) || [];

      if (selectedTemplate.buttons) {
        JSON.parse(selectedTemplate.buttons)?.map((button) => {
          for (let b of button) {
            labelMatches = [
              ...labelMatches,
              ...Object.values(b).reduce((a, c) => {
                //console.log(c, c.match(/#\{[^}]+\}/g))
                if (typeof c === "string" && c.match(/#\{[^}]+\}/g)) {
                  a = [
                    ...a,
                    ...c.match(/#\{[^}]+\}/g)?.map((label) => ({
                      value: label,
                      context: "button",
                    })),
                  ];
                }
                return a;
              }, []),
            ];
          }
        });
      }
      console.log("selectedTemplate : ", selectedTemplate);
      console.log("labelMatches : ", labelMatches);
      if (labelMatches.length > 0) {
        // const parsedLabels = new Set(labelMatches.map((label) => ({ value: label.value.slice(2, -1), context: label.context }))); // #{} 제거
        const parsedLabels = labelMatches.map((label) => ({ value: label.value.slice(2, -1), context: label.context })).filter((label, index, self) => index === self.findIndex((l) => l.value === label.value && l.context === label.context)); // #{} 제거 + 중복 값 제거
        setLabels([...parsedLabels]);
        console.log("labels : ", [...parsedLabels]);
        setDatas(
          [...parsedLabels].reduce((a, c) => {
            console.log("c : ", c);
            a.push({ name: c.value, value: "", type: "", context: c.context });
            return a;
          }, [])
        );
      } else {
        setLabels([]);
      }
    }
  }, [selectedTemplate]);

  useEffect(() => {
    setIsCustomInput(
      Array(datas.length)
        .fill()
        .map((arr, index) => datas[index]["type"] && (datas[index]["type"] === "text" || datas[index]["type"] === "date"))
    );
  }, [datas]);

  const handleChange = (event, index) => {
    let tmpDatas = [...datas];
    if (event.target.value === "custom" || event.target.value === "TODAY()") {
      // Date type 추가
      let type = event.target.value === "custom" ? 'text' : event.target.value === "TODAY()" ? 'date' : ''
      setDatas([...datas.slice(0, index), ...[{ ...datas[index], ...{ type: type } }], ...datas.slice(index + 1, datas.length)]);
      // let tmpIsCustomInput = [...isCustomInput];
      // tmpIsCustomInput[index] = true;
      // setIsCustomInput(tmpIsCustomInput);
    } else {
      tmpDatas[index] = { ...datas[index], value: event.target.value, type: "field" };
      setDatas(tmpDatas);
    }
  };

  const handleCustomInput = (event, index) => {
    let tmpDatas = [...datas];
    // Date type 추가
    let type = tmpDatas[index].type
    tmpDatas[index] = { ...datas[index], value: event.target.value, type: type };
    setDatas(tmpDatas);
  };

  const handleRestart = (index) => {
    setDatas([...datas.slice(0, index), ...[{ ...datas[index], ...{ type: "field" } }], ...datas.slice(index + 1, datas.length)]);
    // let tmpIsCustomInput = [...isCustomInput];
    // tmpIsCustomInput[index] = false;
    // setIsCustomInput(tmpIsCustomInput);
  };

  const handleClick = async () => {
    if (contacts.length === 0) await getContacts();
    console.log(contacts);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFieldSelect = (event) => {
    setSelectedField(event.target.value);
  };

  const handleMappingSelect = (event) => {
    setMappedField(event.target.value);
  };

  return (
    <>
      <StyledPaper style={{ height: "100%" }}>
        <StyledBox component="div">
          <StyledTypo>발송번호 지정</StyledTypo>
        </StyledBox>

        <Grid container alignItems="center" spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item xs={false} sm={5}>
            <Box display="flex" justifyContent="center" width="100%">
              <Select size="small" value={sendTarget?.["type"]} onChange={(event) => setSendTarget({ ...sendTarget, type: event.target.value })} displayEmpty fullWidth>
                <MenuItem value="">데이터 컬럼 선택</MenuItem>
                <MenuItem value="recipient">전화번호</MenuItem>
                <MenuItem value="appUserId">앱유저 아이디</MenuItem>
                {/*<MenuItem value="userKey">사용자 아이디</MenuItem>*/}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={2} sm={2}>
            <Box display="flex" justifyContent="center">
              <ArrowRightAltIcon fontSize="large" style={{ transform: "scaleX(2.5)" }} />
            </Box>
          </Grid>
          <Grid item xs={false} sm={5}>
            <Box width="100%">
              <Select
                PopperComponent={Popper}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                  PaperProps: {
                    style: {
                      maxHeight: 40 * 4.5,
                      //  width: '20ch',
                    },
                  },
                }}
                size="small"
                value={sendTarget?.["value"]}
                onChange={(event) => setSendTarget({ ...sendTarget, value: event.target.value })}
                displayEmpty
                fullWidth>
                <MenuItem value="">데이터 컬럼 선택</MenuItem>
                {defields.map((defield, idx) => (
                  <MenuItem key={idx} value={defield}>
                    {defield}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
        </Grid>
        <br />
        <StyledBox component="div">
          <StyledTypo>템플릿 변수 지정</StyledTypo>
          <Button size="small" variant="contained" onClick={handleClick}>
            상세편집
          </Button>
        </StyledBox>
        <Grid container alignItems="center" spacing={2}>
          {Object.keys(selectedTemplate).length === 0 ? (
            <Grid item xs={12}>
              <Typography variant="body1">템플릿을 선택해주세요</Typography>
            </Grid>
          ) : labels.length === 0 ? (
            <Grid item xs={12}>
              <Typography variant="body1">선택한 템플릿 내용에 변수처리된 부분이 존재하지 않습니다.</Typography>
            </Grid>
          ) : (
            labels.map(
              (label, index) =>
                label.context === "template" && (
                  <>
                    <Grid key={label.value} item xs={false} sm={5}>
                      <Box display="flex" justifyContent="center" width="100%">
                        <Typography variant="body1">{label.value}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Box display="flex" justifyContent="center">
                        <ArrowRightAltIcon fontSize="large" style={{ transform: "scaleX(2.5)" }} />
                      </Box>
                    </Grid>
                    <Grid item xs={false} sm={5}>
                      <Box width="100%">
                        {!isCustomInput[index] ? (
                          <Select
                            PopperComponent={Popper}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              getContentAnchorEl: null,
                              PaperProps: {
                                style: {
                                  maxHeight: 50 * 4.5,
                                  //  width: '20ch',
                                },
                              },
                            }}
                            size="small"
                            value={datas[index]?.["value"]}
                            onChange={(event) => handleChange(event, index)}
                            displayEmpty
                            fullWidth>
                            <MenuItem value="">데이터 컬럼 선택</MenuItem>
                            {defields.map((defield, idx) => (
                              <MenuItem key={idx} value={defield}>
                                {defield}
                              </MenuItem>
                            ))}
                            <MenuItem value="TODAY()">TODAY</MenuItem>
                            <MenuItem value="custom">직접 입력하기</MenuItem>
                          </Select>
                        ) : (
                          <TextField
                            size="small"
                            value={datas[index]?.["value"]}
                            onChange={(event) => handleCustomInput(event, index)}
                            fullWidth
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end" onClick={() => handleRestart(index)}>
                                    <RestartAltIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Box>
                    </Grid>
                  </>
                )
            )
          )}
        </Grid>
        <br />
        <StyledBox component="div">
          <StyledTypo>템플릿 버튼 변수 지정</StyledTypo>
          <Button size="small" variant="contained" onClick={handleClick}>
            상세편집
          </Button>
        </StyledBox>
        <Grid container alignItems="center" spacing={2}>
          {Object.keys(selectedTemplate).length === 0 ? (
            <Grid item xs={12}>
              <Typography variant="body1">템플릿을 선택해주세요</Typography>
            </Grid>
          ) : labels.length === 0 ? (
            <Grid item xs={12}>
              <Typography variant="body1">선택한 템플릿 내용에 변수처리된 부분이 존재하지 않습니다.</Typography>
            </Grid>
          ) : (
            labels.map(
              (label, index) =>
                label.context === "button" && (
                  <>
                    <Grid key={label.value} item xs={false} sm={5}>
                      <Box display="flex" justifyContent="center" width="100%">
                        <Typography variant="body1">{label.value}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Box display="flex" justifyContent="center">
                        <ArrowRightAltIcon fontSize="large" style={{ transform: "scaleX(2.5)" }} />
                      </Box>
                    </Grid>
                    <Grid item xs={false} sm={5}>
                      <Box width="100%">
                        {!isCustomInput[index] ? (
                          <Select
                            PopperComponent={Popper}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              getContentAnchorEl: null,
                              PaperProps: {
                                style: {
                                  maxHeight: 50 * 4.5,
                                  //  width: '20ch',
                                },
                              },
                            }}
                            size="small"
                            value={datas[index]?.["value"]}
                            onChange={(event) => handleChange(event, index)}
                            displayEmpty
                            fullWidth>
                            <MenuItem value="">데이터 컬럼 선택</MenuItem>
                            {defields.map((defield, idx) => (
                              <MenuItem key={idx} value={defield}>
                                {defield}
                              </MenuItem>
                            ))}
                            <MenuItem value="TODAY()">TODAY</MenuItem>
                            <MenuItem value="custom">직접 입력하기</MenuItem>
                          </Select>
                        ) : (
                          <TextField
                            size="small"
                            value={datas[index]?.["value"]}
                            onChange={(event) => handleCustomInput(event, index)}
                            fullWidth
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end" onClick={() => handleRestart(index)}>
                                    <RestartAltIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Box>
                    </Grid>
                  </>
                )
            )
          )}
        </Grid>
      </StyledPaper>

      <StyledDialog open={open} onClose={handleClose}>
        <DialogTitle>미리보기 데이터 선택</DialogTitle>
        <DialogContent>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid item sm={5}>
              <StyledPaper>
                <StyledBox component="div">
                  <StyledTypo>템플릿 변수 지정</StyledTypo>
                </StyledBox>
                <Grid container alignItems="center" spacing={2}>
                  {Object.keys(selectedTemplate).length === 0 ? (
                    <Grid item xs={12}>
                      <Typography variant="body1">템플릿을 선택해주세요</Typography>
                    </Grid>
                  ) : labels.length === 0 ? (
                    <Grid item xs={12}>
                      <Typography variant="body1">선택한 템플릿 내용에 변수처리된 부분이 존재하지 않습니다.</Typography>
                    </Grid>
                  ) : (
                    labels.map(
                      (label, index) =>
                        label.context === "template" && (
                          <>
                            <Grid key={label.value} item xs={false} sm={5}>
                              <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">{label.value}</Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                              <Box display="flex" justifyContent="center">
                                <ArrowRightAltIcon fontSize="large" style={{ transform: "scaleX(2.5)" }} />
                              </Box>
                            </Grid>
                            <Grid item xs={false} sm={5}>
                              <Box width="100%">
                                {!isCustomInput[index] ? (
                                  <Select
                                    PopperComponent={Popper}
                                    MenuProps={{
                                      anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                      },
                                      transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                      },
                                      getContentAnchorEl: null,
                                      PaperProps: {
                                        style: {
                                          maxHeight: 50 * 4.5,
                                          //  width: '20ch',
                                        },
                                      },
                                    }}
                                    size="small"
                                    value={datas?.[index]?.["value"]}
                                    onChange={(event) => handleChange(event, index)}
                                    displayEmpty
                                    fullWidth>
                                    <MenuItem value="">데이터 컬럼 선택</MenuItem>
                                    {defields.map((defield, idx) => (
                                      <MenuItem key={idx} value={defield}>
                                        {defield}
                                      </MenuItem>
                                    ))}
                                    <MenuItem value="TODAY()">TODAY</MenuItem>
                                    <MenuItem value="custom">직접 입력하기</MenuItem>
                                  </Select>
                                ) : (
                                  <TextField
                                    size="small"
                                    value={datas[index]?.["value"]}
                                    onChange={(event) => handleCustomInput(event, index)}
                                    fullWidth
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton edge="end" onClick={() => handleRestart(index)}>
                                            <RestartAltIcon />
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                )}
                              </Box>
                            </Grid>
                          </>
                        )
                    )
                  )}
                </Grid>
                <br />
                <StyledBox component="div">
                  <StyledTypo>템플릿 버튼 변수 지정</StyledTypo>
                </StyledBox>
                <Grid container alignItems="center" spacing={2}>
                  {Object.keys(selectedTemplate).length === 0 ? (
                    <Grid item xs={12}>
                      <Typography variant="body1">템플릿을 선택해주세요</Typography>
                    </Grid>
                  ) : labels.length === 0 ? (
                    <Grid item xs={12}>
                      <Typography variant="body1">선택한 템플릿 내용에 변수처리된 부분이 존재하지 않습니다.</Typography>
                    </Grid>
                  ) : (
                    labels.map(
                      (label, index) =>
                        label.context === "button" && (
                          <>
                            <Grid key={label.value} item xs={false} sm={5}>
                              <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">{label.value}</Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                              <Box display="flex" justifyContent="center">
                                <ArrowRightAltIcon fontSize="large" style={{ transform: "scaleX(2.5)" }} />
                              </Box>
                            </Grid>
                            <Grid item xs={false} sm={5}>
                              <Box width="100%">
                                {!isCustomInput[index] ? (
                                  <Select
                                    PopperComponent={Popper}
                                    MenuProps={{
                                      anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                      },
                                      transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                      },
                                      getContentAnchorEl: null,
                                      PaperProps: {
                                        style: {
                                          maxHeight: 50 * 4.5,
                                          //  width: '20ch',
                                        },
                                      },
                                    }}
                                    size="small"
                                    value={datas[index]?.["value"]}
                                    onChange={(event) => handleChange(event, index)}
                                    displayEmpty
                                    fullWidth>
                                    <MenuItem value="">데이터 컬럼 선택</MenuItem>
                                    {defields.map((defield, idx) => (
                                      <MenuItem key={idx} value={defield}>
                                        {defield}
                                      </MenuItem>
                                    ))}
                                    <MenuItem value="TODAY()">TODAY</MenuItem>
                                    <MenuItem value="custom">직접 입력하기</MenuItem>
                                  </Select>
                                ) : (
                                  <TextField
                                    size="small"
                                    value={datas[index]?.["value"]}
                                    onChange={(event) => handleCustomInput(event, index)}
                                    fullWidth
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton edge="end" onClick={() => handleRestart(index)}>
                                            <RestartAltIcon />
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                )}
                              </Box>
                            </Grid>
                          </>
                        )
                    )
                  )}
                </Grid>
              </StyledPaper>
            </Grid>
            <Grid item sm={7}>
              <StyledPaper>
                <StyledBox component="div">
                  <StyledTypo>Entry Source 데이터 미리보기</StyledTypo>
                </StyledBox>
                <Box sx={{ overflowX: "auto" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>{contacts.length > 0 ? Object.keys(contacts[0]).map((key) => <TableCell>{key}</TableCell>) : ""}</TableRow>
                    </TableHead>
                    <TableBody>
                      {contacts?.map((contact) => (
                        <TableRow>
                          {Object.values(contact).map((value) => (
                            <TableCell>{value}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                      {/* 더 많은 행을 추가하려면 여기에 추가하세요 */}
                    </TableBody>
                  </Table>
                </Box>
              </StyledPaper>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <IconButton
            autoFocus
            onClick={handleClose}
            color="primary"
            style={{
              position: "absolute",
              left: "97%",
              top: "-40px",
              transform: "scale(1.5)",
              // backgroundColor: "lightgray",
              color: "lightgrey",
            }}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </StyledDialog>
    </>
  );
}

export default Mapper;
